import { Delete, Edit } from '@mui/icons-material';
import { ICellRendererParams } from 'ag-grid-community';
import { ActionsCellRenderer } from '../ActionsCellRenderer/ActionsCellRenderer';

export const BuyingEventManagementActionsRenderer = (params: ICellRendererParams) => {
    const { handleEditRow, showDeleteDialog } = params.context;

    return (
        <ActionsCellRenderer
            actions={[
                {
                    icon: <Edit color="info" />,
                    onClick: () => handleEditRow(params.data),
                },
                {
                    icon: <Delete color="error" />,
                    onClick: () => showDeleteDialog(params.data),
                },
            ]}
        />
    );
};
